module.exports = __webpack_public_path__ + "img/pic-bg1@2x.c2bba348.png";